import { connect } from 'react-redux';
import * as R from 'ramda';
import { setGlobalCustomersLoading } from '../store/subscriptionsSlice';
import CustomerSelection from './CustomerSelection';

const mapState = R.applySpec({});

export default connect(mapState, { setGlobalCustomersLoading })(CustomerSelection);
